export const proyectosRouter = [
    {
        path: 'proyectos/list',
        name: 'proyectos list',
        component: () => import('./pages/index')
    }, {
        path: 'proyectos/create',
        name: 'proyectos crear',
        component: () => import('./pages/crearProyecto')
    },{
        path: 'proyectos/editar/:id',
        name: 'proyectos Editar',
        component: () => import('./pages/crearProyecto')
    },{
        path: 'proyectos/observado/:id',
        name: 'proyectos Observado',
        component: () => import('./pages/crearProyecto')
    },{
        path: 'proyectos/recepcion/:id',
        name: 'proyectos Recepcion',
        component: () => import('./pages/showPoryecto')
    },{
        path: 'proyectos/recepcionprecios/:id',
        name: 'proyectos Recepcion Precios',
        component: () => import('./pages/showPoryecto')
    },{
        path: 'proyectos/show/:id',
        name: 'proyectos Show',
        component: () => import('./pages/showPoryecto')
    },{
        path: 'proyectos/visita_tecnica/:id',
        name: 'proyectos visita tecnica',
        component: () => import('./pages/showPoryecto')
    },{
        path: 'empresa/visita_tecnica/:id',
        name: 'empresa visita tecnica',
        component: () => import('./pages/showPoryecto')
    },
    {
        path: 'proyectos/aceptacion/:id',
        name: 'proyectos aceptacion',
        component: () => import('./pages/aceptacion')
    },
    {
        path: 'proyectos/aprobacion/:id',
        name: 'proyectos aprobacion',
        component: () => import('./pages/aceptacion')
    },
    {
        path: 'proyectos/confirmacion/:id',
        name: 'proyectos confirmacion',
        component: () => import('./pages/showPoryecto')
    },
    {
        path: 'proyectos/adjudicacion/:id/:id_institucion',
        name: 'proyectos adjudicacion',
        component: () => import('./pages/adjudicacion')
    },
    {
        path: 'proyectos/seguimiento/:id',
        name: 'proyectos seguimiento',
        component: () => import('./pages/showPoryecto')
    },
    {
        path: 'projects/coordinator/:id',
        name: 'projects coordinator visits',
        component: () => import('./pages/showPoryecto')
    },
    {
        path: 'projects/requests',
        name: 'Projects requests',
        component: () => import('./pages/request/Index')
    },
    {
        path: 'projects/requests/new',
        name: 'Project request new',
        component: () => import('./pages/request/Request')
    },
    {
        path: 'projects/requests/:id',
        name: 'project_request_view',
        component: () => import('./pages/request/Request')
    },
    {
        path: 'projects/requestsDetail/:id',
        name: 'Project request detail',
        component: () => import('./pages/request/RequestDetail')
    },
    {
        path: 'projects/preliminary/:id',
        name: 'project_preliminary_view',
        component: () => import('./pages/request/RequestDetail')
    },
    {
        path: 'projects/preliminaryproject',
        name: 'Project request preliminary',
        component: () => import('./pages/preliminary/Index')
    },

    {
        path: 'projects/requestvisits',
        name: 'Projects requests visits',
        component: () => import('./pages/preliminary/IndexVisit')
    },
]
